export default __webpack_public_path__ + "static/media/pink.943cea93.svg";